import './Header.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';


const Header = observer(
  class Header extends Component {
	
		state = {baba:'dudu'};
		
		logout = () => {
			this.props.flow.ftvfeLogout('','')
				.then(res=>{
					window.location.reload();
				}).catch(e => {
					window.location.reload();
				});
		}
			
    render() {
			return  (
				<Row>
					<Col xs={6} md={6} >
						<div className="header_logo" />
					</Col>
					<Col  xs={6} md={6}  className="tar" >
						<div className="headeruserdiv">
							<div onClick={ this.props.openudata } className="openprofile">{ this.props.user.fname } { this.props.user.name }</div>
							<a href="#" onClick={this.logout} className="deconnexion">Deconnexion</a>
						</div>
					</Col>
				</Row>
			)
    }
		
		
		
  }
)


export default Flow.injectFlow(Header);